import { IExperience } from '../models/experience.interface';

export const EXPERIENCE: IExperience[] = [
  {
    key: 'experience--1',
    title: 'Spoonity Inc.',
    description: 'Full Stack Developer. Took over development on the Spoonity merchant dashboard by working on the UI as well as API support.'
  }, {
    key: 'experience--2',
    title: 'ARC Resources Ltd.',
    description: 'Information Systems Summer Student. Did research and development on migrating in-house applications to cloud-based applications by modifying the continuous development and continuous integration structures and build scripts.'
  }
];